/** @format */

import {Box} from '@mui/material';

import {Trans} from 'react-i18next';

import {TMinVisits} from './interfaces';

import {Description, Input, Title} from './styles';

interface IMinVisitsFieldProps {
  type: TMinVisits;
  value: number;
  dataTestId: string;
  onChange: (
    type: TMinVisits,
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
  ) => void;
}

const MinVisitsFIeld = ({type, value, dataTestId, onChange}: IMinVisitsFieldProps) => {
  const title =
    type === 'minVisits'
      ? 'Минимальное количество визитов'
      : 'Минимальное количество визитов для старых ошибок';
  const description =
    type === 'minVisits'
      ? 'В отчет будут попадать ошибки набравшие минимальное количество визитов.'
      : 'В отчет будут попадать ошибки набравшие минимальное количество визитов для старых ошибок.';

  return (
    <>
      <Box sx={{mb: 4}}>
        <Title>
          <Trans>{title}</Trans>
        </Title>
      </Box>
      <Box sx={{mb: 4}}>
        <Description>
          <Trans>{description}</Trans>
        </Description>
      </Box>
      <Box sx={{mb: 8}}>
        <Input
          type='number'
          onChange={event => onChange(type, event)}
          value={value}
          inputProps={{
            'data-testid': dataTestId,
          }}
        />
      </Box>
    </>
  );
};

export default MinVisitsFIeld;
